import gsap from 'gsap'
import barba from '@barba/core'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Navigation } from './navigation'
import { initLenis, scrollToStart, parallax } from './lenis'
import { initSwiper } from './swiper'
import { initAlpine } from './alpine'
import { initSplitText } from './splitType'
import { initServices } from './services'
import { initWhyUs } from './whyUs'
import { initAnimation } from './animation'
import { generateContentsList } from './article'
import { initSprig } from './sprig'
import { initParallax } from './parallax'
import { initGradientBackground } from './gradientBackground'
import { initBreachPopup } from './popups'
import { refreshScripts, autoplayVideos } from './utilities'
// import { initFormie } from './formie'
import { initScrambleText } from './scrambleText'
import { careers } from './careers'
import { hubspot } from './hubspot'
import { footer } from './footer'

gsap.registerPlugin(ScrollTrigger)

const initBarba = () => {
	window.initialLoad = true

	const nav = new Navigation()

	const initComponents = (data) => {
		initSplitText()
		initSwiper()
		initAnimation()
		initWhyUs()
		parallax()
		initSprig()
		initServices()
		initParallax()
		initGradientBackground()
		initScrambleText()
		initBreachPopup()
		generateContentsList()
		careers()
		hubspot()
		footer()
	}

	barba.init({
		debug: true,
		timeout: 10000,
		schema: {
			prefix: 'data-load'
		},
		prevent: ({ el }) => el.classList.contains('ab-item'),
		transitions: [
			{
				name: 'basic-transition',
				once(data) { },
				leave(data) {
					const done = this.async()
					gsap.to(data.current.container, {
						opacity: 0,
						duration: 0.35,
						onComplete: done
					})
				},
				afterLeave(data) {
					if (data.next.namespace !== 'taxonomy') scrollToStart()
					nav.closeNavigation()
					nav.closeMegaMenu()
					ScrollTrigger.getAll().forEach(t => t.kill())
				},
				after(data) {
					const done = this.async()
					gsap.from(data.next.container, {
						opacity: 0,
						duration: 0.35,
						onComplete: done
					})
				}
			}
		]
	})

	barba.hooks.once((data) => {
		initLenis()
		initAlpine()
		initComponents(data)

		window.onload = function () {
			window.initialLoad = false
			document.documentElement.classList.add('is-ready')
		}
	})

	barba.hooks.enter((data) => {
		if (htmx) {
			htmx.process(data.next.container)
		}
	})

	barba.hooks.after((data) => {
		initComponents(data)
		// initFormie()
		autoplayVideos(data.next.container)
		refreshScripts(data.next.container)
	})
}

export default initBarba